
ADILF.define('adilf/apps/social/promo-modules/collection-promo-base/views/list-view',['require','exports','module','streamhub-sdk/jquery','inherits','streamhub-sdk/content/views/content-list-view','adilf/context','css!streamhub-sdk/css/style.css','less!adilf/apps/social/promo-modules/collection-promo-base/css/styles'],function (require, exports, module) {'use strict';
var jquery = require('streamhub-sdk/jquery');
var inherits = require('inherits');
var ContentListView = require('streamhub-sdk/content/views/content-list-view');
var Context = require('adilf/context');
require('css!streamhub-sdk/css/style.css');
require('less!adilf/apps/social/promo-modules/collection-promo-base/css/styles');

var CollectionPromoListView = function(opts) {
    opts = opts || {};
    opts.animate = false;

    this._contentViewFactory = opts.contentViewFactory || new Error("requires ContentViewFactory");
    if (this._contentViewFactory.setReplying) {
        this._contentViewFactory.setReplying(this._replying);
    }

    ContentListView.call(this, opts);
};
inherits(CollectionPromoListView, ContentListView);

CollectionPromoListView.prototype.elClass += ' collection-promo-list-view';

CollectionPromoListView.prototype.createContentView = function (content) {
    return this._contentViewFactory.createContentView(content, {
        replyCommand: false
    });
};

CollectionPromoListView.prototype.getTemplateContext = function () {
    var context = ContentListView.prototype.getTemplateContext.call(this);
    context.affiliateContext = Context;
    context.socialSettings = window.Advance.Social.settings;
    if(this.opts.featured_or_latest) {
        context.featured_or_latest = this.opts.featured_or_latest.charAt(0).toUpperCase() + this.opts.featured_or_latest.slice(1);
    }
    return context;
};

module.exports = CollectionPromoListView;
});
